var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"headline",attrs:{"cols":"12"}},[_c('img',{staticClass:"logo-print",attrs:{"src":"/favicon.png","alt":""}}),_c('h1',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }